import { Modal, Button } from 'react-bootstrap'
import React, { useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import CloseIcon from "@material-ui/icons/Close";

const CropImageModal = ({ onCrop, data, aspectRatio, onClose, show }) => {
  const [cropper, setCropper] = useState();

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      onCrop(cropper.getCroppedCanvas().toDataURL(), data.name);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size='xl'
      centered
      backdrop="static"
    >
      <Modal.Header className='h-55px'>
        <CloseIcon fontSize='large' onClick={onClose} className='hover-opacity-40 cursor-pointer'/>
        <Modal.Title>
          Crop Image
        </Modal.Title>
        <Button variant="primary" disabled={!cropper} onClick={getCropData}>
          Crop Image
        </Button>
      </Modal.Header>
      <Modal.Body style={{ height: 'calc(100vh - 120px)' }} className='position-relative'>
        <Cropper
          style={{ height: '100%', width: "100%" }}
          preview=".img-preview"
          src={data?.img || data?.thumbnailUrl}
          viewMode={1}
          guides
          minCropBoxHeight={10}
          minCropBoxWidth={10}
          aspectRatio={aspectRatio}
          responsive
          autoCropArea={1}
          checkOrientation={false}
          background={false}
          onInitialized={ instance => setCropper(instance) }
        />
      </Modal.Body>
    </Modal>
  );
}

export default CropImageModal;
